import React from 'react';
import { useChatWidget } from '../../contexts/ChatWidgetContext';
import '../../pages/css/domesticTheme.css';
import styles from './css/ChatLauncherButton.module.css';

function ChatIcon() {
  return (
    <svg className={styles.icon} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg className={styles.icon} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
  );
}

export default function ChatLauncherButton({ badgeCount = 0 }) {
  const { panelState, openPanel, closePanel } = useChatWidget();
  const isOpen = panelState === 'open';
  const isMinimized = panelState === 'minimized';

  const handleClick = () => {
    if (isOpen) {
      closePanel();
    } else {
      openPanel('fab');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  const ariaLabel = isOpen
    ? 'Close chat'
    : isMinimized
    ? 'Restore chat'
    : 'Open chat';

  return (
    <button
      type="button"
      className={`${styles.fab} domestic-design-scope`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      aria-label={ariaLabel}
      tabIndex={0}
    >
      {isOpen ? <CloseIcon /> : <ChatIcon />}
      {isMinimized && (
        <span
          className={styles.minimizedDot}
          aria-hidden="true"
          title="Chat is minimized"
        />
      )}
      {badgeCount > 0 && !isOpen && (
        <span className={styles.badge} aria-hidden="true">
          {badgeCount > 99 ? '99+' : badgeCount}
        </span>
      )}
    </button>
  );
}
